import { useInternalDynamicContext } from '../../../context/DynamicContext/useInternalDynamicContext.js';
import { useViewContext } from '../../../context/ViewContext/ViewContext.js';

const useHandleWalletsToConnect = () => {
    const { walletsToConnectByChain, setWalletsToConnectByChain, setShowAuthFlow, setIsFullyConnected, isFullyConnected, } = useInternalDynamicContext();
    const { setView, goToInitialView } = useViewContext();
    const handleWalletsToConnect = () => {
        if (!walletsToConnectByChain) {
            setIsFullyConnected(true);
            setShowAuthFlow(false);
            return;
        }
        // Avoid showing wallet-list when wallet updates network to the correct one in run time (bridge mode)
        if (walletsToConnectByChain.length === 0) {
            setShowAuthFlow(false);
            return goToInitialView();
        }
        const [firstWallet, ...restOfTheWallets] = walletsToConnectByChain;
        if (firstWallet.numberOfWallets > 1) {
            const updatedWallets = [
                Object.assign(Object.assign({}, firstWallet), { numberOfWallets: firstWallet.numberOfWallets - 1 }),
                ...restOfTheWallets,
            ];
            setWalletsToConnectByChain(updatedWallets);
            setView('wallet-list');
            return;
        }
        setWalletsToConnectByChain(restOfTheWallets);
        const allWalletsConnected = restOfTheWallets.length === 0;
        if (allWalletsConnected) {
            if (!isFullyConnected) {
                setIsFullyConnected(true);
                setView('bridge-summary');
            }
            else {
                setShowAuthFlow(false);
                goToInitialView();
            }
            return;
        }
        setView('bridge-next-wallet-connection');
    };
    return { handleWalletsToConnect };
};

export { useHandleWalletsToConnect };
